type LogLevel = "info" | "warn" | "error";

type LogContext = Record<string, unknown> | undefined;

interface LogPayload {
  level: LogLevel;
  message: string;
  context?: LogContext;
  timestamp: string;
}

const log = (level: LogLevel, message: string, context?: LogContext): void => {
  const payload: LogPayload = {
    level,
    message,
    context,
    timestamp: new Date().toISOString(),
  };

  if (level === "error") {
    console.error(payload);
    return;
  }
  if (level === "warn") {
    console.warn(payload);
    return;
  }
  console.info(payload);
};

export const logger = {
  info: (message: string, context?: LogContext) => log("info", message, context),
  warn: (message: string, context?: LogContext) => log("warn", message, context),
  error: (message: string, context?: LogContext) => log("error", message, context),
};

